"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGenericPortals = void 0;
var domain_1 = require("@genoa/domain");
exports.mockGenericPortals = [
    {
        id: 17,
        public_id: 'appfolio',
        portal_name: 'appfolio',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 17,
            login_url: 'https://robinsongroup.appfolio.com/connect/users/sign_in',
            forgot_password_url: 'https://robinsongroup.appfolio.com/connect/users/sign_in',
            register_url: 'https://robinsongroup.appfolio.com/connect/users/sign_in',
            logo_url: 'https://assets.getflex.com/appfolio-White.png',
            color_logo_url: 'https://assets.getflex.com/appfolio.png',
            background_color: '#000111',
            foreground_color: '#FFFFFF',
            username_field_name: 'username',
            password_field_name: 'password',
        },
        display_name: 'Appfolio',
        generic_portal_identity_biller_id: 11207,
        created_at: '2023-03-09',
        updated_at: '2023-03-09',
    },
    {
        id: 18,
        public_id: 'rec5RmNogZ3VYNm1R',
        portal_name: 'activebuilding',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 18,
            login_url: 'https://login.activebuilding.com/auth/login',
            forgot_password_url: 'https://login.activebuilding.com/support/forgot-password',
            register_url: '',
            logo_url: 'https://assets.getflex.com/activebuilding-white.png',
            color_logo_url: 'https://assets.getflex.com/activebuilding.png',
            background_color: '#18AAD9',
            foreground_color: '#ffffff',
            username_field_name: 'Email',
            password_field_name: 'password',
        },
        display_name: 'Active Building',
        generic_portal_identity_biller_id: 11208,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 19,
        public_id: 'recoZ9ems06u1zidT',
        portal_name: 'aptexx',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 19,
            login_url: 'https://aptx.cm/#/person/login/',
            forgot_password_url: 'https://aptx.cm/#/person/login/pane/forgotPassword/',
            register_url: '',
            logo_url: 'https://assets.getflex.com/Aptexx-White.png',
            color_logo_url: 'https://assets.getflex.com/Aptexx.png',
            background_color: '#f9a11b',
            foreground_color: '#ffffff',
            username_field_name: 'Email',
            password_field_name: '4 Digit PIN',
        },
        display_name: 'Campus Village',
        generic_portal_identity_biller_id: 11209,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 21,
        public_id: 'reckMJnBDJXdsGxUu',
        portal_name: 'salesforce',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 21,
            login_url: 'https://jwbcompanies.force.com/resident/s/login/?ec=302&startURL=%2Fresident%2Fs%2F',
            forgot_password_url: 'https://jwbcompanies.force.com/resident/s/login/?ec=302&startURL=%2Fresident%2Fs%2F',
            register_url: 'https://jwbcompanies.force.com/resident/s/login/?ec=302&startURL=%2Fresident%2Fs%2F',
            logo_url: 'https://assets.getflex.com/salesforceLogoWhite.png',
            color_logo_url: 'https://assets.getflex.com/salesforceLogoColor.png',
            background_color: '#0090bf',
            foreground_color: '#ffffff',
            username_field_name: 'Username',
            password_field_name: 'Password',
        },
        display_name: 'Salesforce',
        generic_portal_identity_biller_id: 11210,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 22,
        public_id: 'bv2599cc5c9e4094a3383ef77bbdab6c708',
        portal_name: 'fortress',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 22,
            login_url: 'https://www.fortresstech.io/',
            forgot_password_url: 'https://app.fortresstech.io/login',
            register_url: 'https://www.fortresstech.io/',
            logo_url: 'https://assets.getflex.com/Fortress.png',
            color_logo_url: 'https://assets.getflex.com/Fortress.png',
            background_color: '#ffffff',
            foreground_color: '#000000',
            username_field_name: 'Username',
            password_field_name: 'Password',
        },
        display_name: 'Fortress',
        generic_portal_identity_biller_id: 11211,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 23,
        public_id: 'recV3M756k11ISmbI',
        portal_name: 'amcrentpay',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 23,
            login_url: 'https://www.amcrentpay.com/account/login.aspx',
            forgot_password_url: 'https://www.amcrentpay.com/account/Reset.aspx',
            register_url: '',
            logo_url: 'https://assets.getflex.com/amc_logo-white.png',
            color_logo_url: 'https://assets.getflex.com/amc%20logo.png',
            background_color: '#bed898',
            foreground_color: '#ffffff',
            username_field_name: 'Username',
            password_field_name: 'Password',
        },
        display_name: 'AMC RentPay',
        generic_portal_identity_biller_id: 11212,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 26,
        public_id: 'recgsLUbr61DUWkVK',
        portal_name: 'clickpay',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 26,
            login_url: 'https://www.clickpay.com/custom/clickpay/login.html',
            forgot_password_url: 'https://www.clickpay.com/resetpassword.aspx',
            register_url: 'https://www.clickpay.com/UserProfile.aspx',
            logo_url: 'https://assets.getflex.com/clickpay-logo-white.png',
            color_logo_url: 'https://assets.getflex.com/clickpay-logo.png',
            background_color: '#2F8D3F',
            foreground_color: '#ffffff',
            username_field_name: 'Username or Email',
            password_field_name: 'Password',
        },
        display_name: 'Clickpay',
        generic_portal_identity_biller_id: 11213,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 27,
        public_id: 'recj09HY4wiOlOA8Q',
        portal_name: 'domuso',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 27,
            login_url: 'https://app.domuso.com/',
            forgot_password_url: 'https://app.domuso.com/register/forgotPassword',
            register_url: 'https://www.domuso.com/pay-my-rent/',
            logo_url: 'hhttps://assets.getflex.com/Domuso_Logo-01-White.png',
            color_logo_url: 'https://assets.getflex.com/domuso.png',
            background_color: '#f26925',
            foreground_color: '#ffffff',
            username_field_name: 'Email',
            password_field_name: 'Password',
        },
        display_name: 'Domuso',
        generic_portal_identity_biller_id: 11214,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 29,
        public_id: 'reclQoRFKFsjJcnE5',
        portal_name: 'manageamerica',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 29,
            login_url: 'https://www.communityresport.com/',
            forgot_password_url: 'https://www.communityresport.com/',
            register_url: 'https://www.communityresport.com/',
            logo_url: 'https://assets.getflex.com/manageAmericaWhite.png',
            color_logo_url: 'https://assets.getflex.com/manageAmericaColor.png',
            background_color: '#666666',
            foreground_color: '#ffffff',
            username_field_name: 'Username',
            password_field_name: 'Password',
        },
        display_name: 'Manage America',
        generic_portal_identity_biller_id: 11215,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 31,
        public_id: 'recWbvXQwh1PNtspM',
        portal_name: 'mymadera',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 31,
            login_url: 'https://my.maderaresidential.com/',
            forgot_password_url: 'https://my.maderaresidential.com/reset',
            register_url: 'https://my.maderaresidential.com/register',
            logo_url: 'https://assets.getflex.com/maderaLogoWhite.png',
            color_logo_url: 'https://assets.getflex.com/maderaLogoColor.png',
            background_color: '#4a4e7a',
            foreground_color: '#ffffff',
            username_field_name: 'Email',
            password_field_name: 'Password',
        },
        display_name: 'My Madera',
        generic_portal_identity_biller_id: 11216,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
    {
        id: 35,
        public_id: 'recw4rgICXxEzkY5C',
        portal_name: 'zego',
        status: domain_1.BillerPropertyStatus.ACTIVE,
        portal_display_config: {
            id: 35,
            login_url: 'https://payments.gozego.com/login',
            forgot_password_url: 'https://payments.gozego.com/registration/forgot_password/login',
            register_url: 'https://payments.gozego.com/registration',
            logo_url: 'https://assets.getflex.com/Zego%20Logo_white.png',
            color_logo_url: 'https://assets.getflex.com/Zego.png',
            background_color: '#5C6274',
            foreground_color: '#ffffff',
            username_field_name: 'email/username',
            password_field_name: 'Password',
        },
        display_name: 'Zego',
        generic_portal_identity_biller_id: 11217,
        created_at: '2023-11-03',
        updated_at: '2023-11-03',
    },
];
